export const selectedRange = (state, payload) => {
    return {
      ...state,
      heatmapConfiguration: {
        ...state.heatmapConfiguration,
        displayColorLogic: payload.value,
        thresholdValue:payload.thresholdValueArray
      },
    };
  };